import { VegaChip } from '@globalpayments/vega-react';
import * as _ from 'lodash';

import { ComponentStatus, ComponentStatusCheck } from '../../../types/componentStatus';

export const descriptionFromBuildDate = (buildDate: string | null | undefined): string => {
  const tokens = _.chain(buildDate || '')
    .replace(')', '')
    .split('(')
    .value();
  return tokens.length ? tokens[1] : '';
};

export const statusLabel = (component: ComponentStatusCheck): string => {
  if (component.isLoadingStatus) return 'Loading status';
  return component.statusResult?.status ?? ComponentStatus.Unknown;
};

export const statusColor = (
  status: ComponentStatus | undefined,
): React.ComponentProps<typeof VegaChip>['statusColor'] => {
  switch (status) {
    case ComponentStatus.Healthy:
      return 'bg-status-success';
    case ComponentStatus.Unhealthy:
      return 'bg-status-error';
    default:
      return 'bg-status-warning';
  }
};
